import { useEffect } from 'react';

const useFormUrlSync = (formik, urlValues, fieldMappings) => {
  useEffect(() => {
    const newValues = { ...formik.values };
    let hasChanges = false;

    fieldMappings.forEach(({ formPath, urlValue }) => {
      // Split the form path into parts (e.g., "profile.name" -> ["profile", "name"])
      const pathParts = formPath.split('.');

      // Handle nested objects
      if (pathParts.length > 1) {
        let current = newValues;
        for (let i = 0; i < pathParts.length - 1; i++) {
          if (!current[pathParts[i]]) {
            current[pathParts[i]] = {};
          }
          current = current[pathParts[i]];
        }

        const lastPart = pathParts[pathParts.length - 1];
        if (!current[lastPart] && urlValue) {
          current[lastPart] = urlValue;
          hasChanges = true;
        }
      }

      // Handle top-level fields
      else if (!newValues[formPath] && urlValue) {
        newValues[formPath] = urlValue;
        hasChanges = true;
      }
    });

    if (hasChanges) {
      formik.setValues(newValues);
    }
  }, [urlValues, formik.values]);
};

export default useFormUrlSync;
